import React, { useState, useEffect } from "react";
import { editOrgProfile, uploadOrgLogo } from "../Services/orgService";
import { useNavigate } from "react-router-dom";
import { getOrganizationDetails } from "../Services/AdminService";
import {
  IOrganizationDetails,
  IOrgProfileData,
} from "../Interfaces/IorgProfile";
import "../Style/EditOrgProfile.css";
import "../Style/Common.css";
import Footer from "../Footer/Footer";
import Swal from "sweetalert2";
import { indianStates } from "../Services/CommonService";
import { Container, Box } from "@mui/material";

//This for will work for Org creation as well
interface OrgProfileFormProps {
  mode: "create" | "edit";
  orgId: string; // Data for editing
}

const EditOrgProfileForm: React.FC<OrgProfileFormProps> = ({
  mode = "edit",
  orgId,
}) => {
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [showGSTField, setShowGSTField] = useState(false);
  //const [formData, setFormData] = useState<Partial<IOrgProfileData>>({});
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [showLogoUpload,setShowLogoUpload]=useState(true)

  const [formData, setFormData] = useState<Partial<IOrganizationDetails>>({
    email: "",
    phone: 0,
    OwnerName: "",
    OrgName: "",
    orgId: "",
    status: "",
    userType: "",
    validUpThroughDate: undefined,
    validFromDate: undefined,
    sysIP: "",
    creationDate: undefined,
    orgLocation: "",
    industory: "",
    timeZone: "",
    currency: "",
    accountDetails: [],
    address: [
      {
        addressLine2: "",
        zipCode: 0,
        addressLine1: "",
        city: "",
        state: "",
      },
    ],
    GST: 0,
    createdBy: "",
    createdSysIp: 0,
    logo: "",
    termAndCondition: "",
  });

  const [apiResponse, setApiResponse] = useState<string | null>(null);
  const navigate = useNavigate();

  // Populate form data for edit mode
  useEffect(() => {
    const fetchOrgDetails = async () => {
      try {
        const orgId = localStorage.getItem('orgId') ?? ''; 
        const response = await getOrganizationDetails(orgId); // Pass org Id
        const data = response;
        if (data) {
          setFormData(data);
          if (data.GST) {
            setShowGSTField(true);
          }
        } else {
          throw new Error(
            data.message || "Failed to fetch organization details"
          );
        }
      } catch (err: any) {
        //    setError(err.message);
      } finally {
        //  setLoading(false);
      }
    };
    fetchOrgDetails();
  }, [mode, orgId]);
  const handleAddAddressClick = () => setShowAddressPopup(true);
  const handleClosePopup = () => setShowAddressPopup(false);
  const handleGSTCheckbox = () => setShowGSTField(!showGSTField);
  const handleClosePopupLogoUpload = () => setShowLogoUpload(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    index?: number,
    type?: "address" | "accountDetails"
  ) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      const validNumber = /^\d{10}$/;
      if (!validNumber.test(value)) {
        return;
      }
    }

    setFormData((prevState) => {
      if (type === "address" && index !== undefined) {
        // Handle address update
        const updatedAddresses = [...(prevState.address || [])];
        updatedAddresses[index] = {
          ...updatedAddresses[index],
          [name]: value,
        };
        //
        return {
          ...prevState,
          address: updatedAddresses,
        };
      } else if (type === "accountDetails" && index !== undefined) {
        // Handle account details update
        const updatedAccounts = [...(prevState.accountDetails || [])];
        updatedAccounts[index] = {
          ...updatedAccounts[index],
          [name]: value,
        };
        return {
          ...prevState,
          accountDetails: updatedAccounts,
        };
      }
//
      // Handle other formData fields
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const validateForm = () => {
    const errors: string[] = [];

    // Check required fields
    if (!formData.OrgName) {
      errors.push("Organization Name is required.");
    }
    if (!formData.orgLocation) {
      errors.push("Organization Location is required.");
    }
    if (!formData.email) {
      errors.push("Email is required.");
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.push("Email is invalid.");
    }
    if (!formData.phone) {
      errors.push("Mobile Number is required.");
    } else if (formData.phone.toString().length < 10) {
      errors.push("Mobile Number must be at least 10 digits.");
    }
    if (!formData.industory) {
      errors.push("Industry is required.");
    }
    if (!formData.currency) {
      errors.push("Currency is required.");
    }
    if (!formData.timeZone) {
      errors.push("Time Zone is required.");
    }
    if (showGSTField && !formData.GST) {
      errors.push("GST Number is required.");
    }

    // Check for account details if necessary
    if (formData.accountDetails && formData.accountDetails.length > 0) {
      formData.accountDetails.forEach((account, index) => {
        if (!account.accountHolderName) {
          errors.push(`Account Holder Name is required for account ${index + 1}.`);
        }
        if (!account.accountNumber) {
          errors.push(`Account Number is required for account ${index + 1}.`);
        }
        if (!account.bankName) {
          errors.push(`Bank Name is required for account ${index + 1}.`);
        }
        if (!account.ifscCode) {
          errors.push(`IFSC Code is required for account ${index + 1}.`);
        }
      });
    }

    if (errors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: errors.join("<br>"),
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }

    return errors;
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      Swal.fire({
        title: "Validation Errors",
        text: validationErrors.join("\n"),
        icon: "error",
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      return; // Stop submission if there are validation errors
    }
  
    try {
      if (mode === "create") {
        // const response = await createOrgProfile(formData);
        // setApiResponse(
        //   `Record's saved successfully. Your User ID: ${response.userDetails.userId} and Password: ${response.userDetails.password}`
        // );
      } else if (mode === "edit") {
        if (logoFile) {
          await handleLogoUpload();
        }
  
        await editOrgProfile(formData); // Add edit API
        Swal.fire({
          title: "Organization details updated successfully.",
          icon: "success",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error: any) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };
  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   try {
  //     if (mode === "create") {
  //       // const response = await createOrgProfile(formData);
  //       // setApiResponse(
  //       //   `Record's saved successfully. Your User ID: ${response.userDetails.userId} and Password: ${response.userDetails.password}`
  //       // );
  //     } else if (mode === "edit") {
  //       if (logoFile) {
  //         await handleLogoUpload();
  //       }

  //       await editOrgProfile(formData); // Add edit API
  //       Swal.fire({
  //         title: "Organization details updated successfully.",
  //         icon: "success",
  //         toast: true,
  //         position: "center",
  //         showConfirmButton: false,
  //         timer: 3000,
  //         timerProgressBar: true,
  //       });
  //     }
  //   } catch (error: any) {
  //     Swal.fire({
  //       title: "Error",
  //       text: error.message,
  //       icon: "error",
  //       toast: true,
  //       position: "top-end",
  //       showConfirmButton: false,
  //       timer: 3000,
  //       timerProgressBar: true,
  //     });
  //   }
  // };
  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setLogoFile(file); // Store the file for upload
      setFormData((prevState) => ({
        ...prevState,
        logo: URL.createObjectURL(file), // Display a preview
      }));
    }
  };
  const handleLogoUpload = async () => {
    if (!logoFile) return;

    try {
      const response = await uploadOrgLogo(logoFile);
      if(response.publicUrl)
      {
        formData.logo=response.publicUrl;
      }
      console.log("Logo uploaded successfully:", response);
      Swal.fire({
        title: "Logo uploaded successfully.",
        icon: "success",
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      setShowLogoUpload(true);
    } catch (error: any) {
      console.error("Error uploading logo:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to upload logo. Please try again.",
        icon: "error",
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };
  
  
  //const handleRedirect = () => navigate("/dashboard/Admin/edit-org");
  return (
    <>
      <div className="page-location">
        <span>Admin &gt; Edit Org Profile</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
      {/* <h2>
        {mode === "create" ? "Setup Your Org Profile" : "Edit Org Profile"}
      </h2> */}
      <form>
        <form className="org-form">
          <div className="form-group_org">
            <label style={{ fontWeight: "bold", marginRight: "10px", whiteSpace: "nowrap" }}>Org Name<span style={{ color: "red" }}>*</span></label>
            <input
              name="OrgName"
              type="text"
              value={formData?.OrgName || ""}
              onChange={handleChange} required/>
          </div>

          <div className="form-group_org">
            <label style={{ fontWeight: "bold", marginRight: "10px", whiteSpace: "nowrap" }}>Org Location<span style={{ color: "red" }}>*</span></label>
            <select
              name="orgLocation"
              value={formData?.orgLocation || ""}
              onChange={handleChange}
              required
              disabled
            >
              <option value="India">India</option>
              <option value="USA">USA</option>
            </select>
          </div>

          <div className="form-group_org">
            <label style={{ fontWeight: "bold", marginRight: "10px", whiteSpace: "nowrap" }}>Email<span style={{ color: "red" }}>*</span></label>
            <input
              name="email"
              type="email"
              value={formData?.email || ""}
              onChange={handleChange}  required/>
          </div>

          <div className="form-group_org">
            <label style={{ fontWeight: "bold", marginRight: "10px", whiteSpace: "nowrap" }}>Mobile Number<span style={{ color: "red" }}>*</span></label>
            <input
              name="phone"
              type="number"
              value={formData?.phone || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.startsWith('-')) {
                  Swal.fire({
                    title: "Error",
                    text: "Mobile number should not be negative.",
                    icon: "error",
                    toast: true,
                    position: "center",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                  });
                  e.target.value = '';
                } else if (value.length > 13) {
                  Swal.fire({
                    title: "Error",
                    text: "Mobile number is invalid.",
                    icon: "error",
                    toast: true,
                    position: "center",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                  });
                  e.target.value = '';
                } else {
                  handleChange(e);
                }
              }}
              pattern="\d*"
              maxLength={13}
              required
              title="Mobile number must be between 1 and 13 digits."
            />
          </div>

          <div className="form-group_org">
            <label style={{ fontWeight: "bold", marginRight: "10px", whiteSpace: "nowrap" }}>Industry</label>
            <select
              name="industory"
              value={formData?.industory || ""}
              onChange={handleChange}
            >
            <option value="">Select Industry</option>
            <option value="Hardware">Hardware</option>
            <option value="Hardware_Paints">Hardware & Paints</option>
            <option value="Building_Material_Supplier"> Building Material Supplier</option>
            <option value="Die_Tools_Manufacturer">Die and Tools Manufacturer</option>
            <option value="Plumbing">Plumbing</option>
            <option value="Mobile">Mobile </option>
            <option value="Electronics">Electronics</option>
            <option value="Electrical">Electrical </option>
            <option value="Automobile">Automobile</option>
            <option value="Furniture">Furniture </option>
            <option value="Manufacturing">Manufacturing</option>
            <option value="Traders">Traders</option>
            <option value="Jewellery">Jewellery</option>
            <option value="AnimalFeed">Animal Feed</option>
            <option value="BookStores">Book Stores</option>
            <option value="FruitsAndVegetables">Fruits & Vegetables</option>
            </select>
          </div>
          <div className="form-group_org">
            <label style={{ fontWeight: "bold", marginRight: "10px", whiteSpace: "nowrap" }}>Currency <span style={{ color: "red" }}>*</span></label>
            <select
              name="currency"
              value={formData?.currency || ""}
              onChange={handleChange}
              required
              disabled
            >
              {/* <option value="">Select Currency</option> */}
              <option value="INR">INR - Indian Rupees</option>
              <option value="USD">USD - US Dollars</option>
            </select>
          </div>

          <div className="form-group_org">
            <label style={{ fontWeight: "bold", marginRight: "10px", whiteSpace: "nowrap" }}>Time Zone<span style={{ color: "red" }}>*</span></label>
            <select
              name="timeZone"
              value={formData?.timeZone || ""}
              onChange={handleChange}
              required
              disabled
            >
              {/* <option value="">Select Time Zone</option> */}
              <option value="IST">UTC+5:30 India Standard Time</option>
              <option value="EST">UTC-5:00 Eastern Standard Time</option>
            </select>
          </div>
        </form>

        <div className="form-group_org">
          <button className="add-button" type="button" onClick={handleAddAddressClick}>
            Add Org Address
          </button>
        </div>

        <div
          className="form-checkbox"
          // style={{ display: "flex", alignItems: "center" }}
        >
          <input
            name="GST"
            type="checkbox"
            checked={showGSTField}
            onChange={handleGSTCheckbox}
            style={{ marginRight: "10px", width: "15px" }} required/>
          <label htmlFor="gstCheckbox">GST<span style={{ color: "red" }}>*</span></label>
        </div>
        {showGSTField && (
          <div className="form-Gst">
            <label>GST Number<span style={{ color: "red" }}>*</span></label>
            <input
              name="GST"
              type="text"
              value={formData?.GST || ""}
              onChange={handleChange} required/>
          </div>
        )}

        <h2>Bank Details</h2>
        <div className="org-section">
          {formData.accountDetails ? (
            formData.accountDetails.map((account: any, index: number) => (
              <div key={index}>
                <div className="form-group_org">
                  <label>
                    <strong>Account Holder Name<span style={{ color: "red" }}>*</span>:</strong>
                  </label>
                  <input
                    name="accountHolderName"
                    type="text"
                    value={account?.accountHolderName || ""}
                    onChange={(e) => handleChange(e, index, "accountDetails")} />
                </div>

                <div className="form-group_org">
                  <label>
                    <strong>Account Number<span style={{ color: "red" }}>*</span>:</strong>
                  </label>
                  <input
                    name="accountNumber"
                    type="text"
                    value={account?.accountNumber || ""}
                    onChange={(e) => handleChange(e, index, "accountDetails")} required/>
                </div>
                <div className="form-group_org">
                  <label>
                    <strong>Bank Name<span style={{ color: "red" }}>*</span>:</strong>
                  </label>
                  <input
                    name="bankName"
                    type="text"
                    value={account?.bankName || ""}
                    onChange={(e) => handleChange(e, index, "accountDetails")} required/>
                </div>
                <div className="form-group_org">
                  <label>
                    <strong>IFSC Code<span style={{ color: "red" }}>*</span>:</strong>
                  </label>
                  <input
                    name="ifscCode"
                    type="text"
                    value={account?.ifscCode || ""}
                    onChange={(e) => handleChange(e, index, "accountDetails")} required/>
                </div>
              </div>
            ))
          ) : (
            <p>No Bank Details Available</p>
          )}
        </div>

        <div className="form-actions">
          <label>Terms and Conditions:</label>
          <input
            name="termAndCondition"
            type="textarea"
            value={formData?.termAndCondition || ""}
            onChange={handleChange} />
        </div>
      </form>

      {showAddressPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>Enter Address Details</h3>

            {formData.address && formData.address.length > 0 ? (
              formData.address.map((addr: any, index: number) => (
                <div key={index}>
                  <div className="form-group_org">
                    <label>Address Line 1</label>
                    <input
                      name="addressLine1"
                      type="text"
                      value={addr?.addressLine1 || ""}
                      onChange={(e) => handleChange(e, index, "address")} />
                  </div>
                  <div className="form-group_org">
                    <label>Address Line 2</label>
                    <input
                      name="addressLine2"
                      type="text"
                      value={addr?.addressLine2 || ""}
                      onChange={(e) => handleChange(e, index, "address")} />
                  </div>
                  <div className="form-group_org">
                    <label>City</label>
                    <input
                      name="city"
                      type="text"
                      value={addr?.city || ""}
                      onChange={(e) => handleChange(e, index, "address")} />
                  </div>
                  <div className="form-group_org">
                    <label>State</label>
                    {/* <input
                      name="state"
                      type="text"
                      value={addr?.state || ""}
                      onChange={(e) => handleChange(e, index, "address")} /> */}
                <select
                name="state"
                value={addr?.state || ""}
                onChange={(e) => handleChange(e, index, "address")}
                required
                >
                <option value="">Select State</option>
                {indianStates.map((state) => (
                  <option key={state.value} value={state.label} >
                    {state.label}
                  </option>
                ))}
                </select>
                    </div>
                  <div className="form-group_org">
                    <label>ZIP Code</label>
                    <input
                      name="zipCode"
                      type="text"
                      value={addr?.zipCode || ""}
                      onChange={(e) => handleChange(e, index, "address")} />
                  </div>
                </div>
              ))
            ) : (
              <p>No Address Available</p>
            )}

            <div className="form-actions">
              <button className="submit-button" type="button" onClick={handleClosePopup}>
                Save Address
              </button>
              <button className="cancel-button" type="button" onClick={handleClosePopup}>
                Cancel
              </button>

            </div>
            
          </div>
        </div>
      )}

      <div className="file-upload-container">
        <label>Upload Logo</label>
        <input className="file-input" type="file" accept="image/*" onChange={handleLogoChange} />
        {formData.logo && (
          <div>
            <h6>Current Logo:</h6>
            <img
              src={formData.logo}
              alt="Organization Logo"
              style={{ width: "100px", height: "100px", objectFit: "contain" }} />
          </div>
        )}
        {logoFile && (
          <button className="submit-button" type="button" onClick={handleLogoUpload}>
            Upload Logo
          </button>
        )}

      </div>
      <div className="form-actions">
          <button className="submit-button" type="submit" onClick={handleSubmit}>
            {mode === "create" ? "Submit" : "Update"}
          </button>
          <button className="cancel-button" type="button" onClick={() => navigate("/dashboard")}>
            Cancel
          </button>
        </div>

      {apiResponse && showLogoUpload && (
        <div className="popup">
          <div className="popup-content">
            <p>{apiResponse}</p>
            <button onClick={handleClosePopupLogoUpload}>OK</button>
          </div>
        </div>
      )}
    </Container>
      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
        }}
      >
        <Footer />
      </Box></>  
  );
};

export default EditOrgProfileForm;
